import type { UnitDisclosureListItem } from '../lib/api';
import { formatDateTime } from '../utils/date';

export type DisclosureStatus = 'Missing' | 'Draft' | 'Complete' | 'Included';

export function getDisclosureStatus(item: UnitDisclosureListItem): DisclosureStatus {
  if (!item.hasFields) return 'Included';
  if (!item.record) return 'Missing';
  if (item.record.status === 'COMPLETE') return 'Complete';
  return 'Draft';
}

export function formatDisclosureId(id: string): string {
  return id.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatDisclosureDate(isoString: string | null): string {
  if (!isoString) return 'Never';
  return formatDateTime(isoString, { year: 'numeric', month: 'short', day: 'numeric' });
}

export const disclosureStatusStyles: Record<DisclosureStatus, string> = {
  Missing: 'bg-destructive/10 text-destructive border-destructive/20',
  Draft: 'bg-muted text-muted-foreground border-border',
  Complete: 'bg-success/10 text-success border-success/20',
  Included: 'bg-primary/10 text-primary border-primary/20',
};
